// Dummy results data shared by all Results variants.
// Replace with computed scoring once the productive pipeline is wired in.

export const overallScore = 76;
export const overallMax = 100;
export const verbalLabel = 'Solide Basis';

export const groups = [
  {
    id: 'gemuese',
    emoji: '🥬',
    name: 'Gemüse',
    radarLabel: 'Gemüse',
    score: 88,
    feedback:
      'Du isst regelmässig Gemüse und nutzt eine gute Vielfalt. Das ist eine der stärksten Säulen einer ausgewogenen Ernährung.',
    suggestion: 'Versuche, jeden Tag zwei verschiedene Farben auf dem Teller zu haben.',
  },
  {
    id: 'fruechte',
    emoji: '🍎',
    name: 'Früchte',
    radarLabel: 'Früchte',
    score: 82,
    feedback:
      'Solider Konsum von Früchten. Saisonale Vielfalt würde das Bild noch runder machen.',
    suggestion: 'Beerenobst im Sommer und Kernobst im Winter geben Abwechslung übers Jahr.',
  },
  {
    id: 'tier-prot',
    emoji: '🥩',
    name: 'Tierische Proteine',
    radarLabel: 'Fleisch/Fisch',
    score: 70,
    feedback:
      'Ausgewogener Konsum von Fleisch und Fisch. Etwas mehr Fisch wäre günstig.',
    suggestion: 'Ein- bis zweimal pro Woche Fisch deckt die Empfehlung ab.',
  },
  {
    id: 'pflanz-prot',
    emoji: '🌱',
    name: 'Pflanzliche Proteine',
    radarLabel: 'Hülsenfr.',
    score: 45,
    feedback:
      'Hier liegt das grösste Potenzial. Hülsenfrüchte, Tofu und Nüsse kommen in deiner Woche selten vor. Pflanzliche Proteine sind eine wichtige Ergänzung zu tierischen Quellen.',
    suggestion: 'Ein Linsensalat als Mittagessen oder Hummus aufs Brot bringt schon viel.',
  },
  {
    id: 'getreide',
    emoji: '🌾',
    name: 'Getreide',
    radarLabel: 'Getreide',
    score: 65,
    feedback: 'Der Anteil an Vollkornprodukten könnte höher sein.',
    suggestion: 'Vollkornbrot statt Weissbrot ist ein einfacher Tausch.',
  },
  {
    id: 'milch',
    emoji: '🥛',
    name: 'Milchprodukte',
    radarLabel: 'Milch',
    score: 78,
    feedback: 'Guter Konsum, gute Auswahl ungesüsster Varianten.',
    suggestion: 'Naturejoghurt mit frischen Früchten statt Fruchtjoghurt.',
  },
  {
    id: 'getranke',
    emoji: '💧',
    name: 'Getränke',
    radarLabel: 'Getränke',
    score: 90,
    feedback:
      'Du trinkst genügend Wasser und meidest gezuckerte Getränke. Sehr gut.',
    suggestion: 'Weiter so. Ungesüsster Tee zählt auch dazu.',
  },
];

export function statusFor(score) {
  if (score >= 80) return 'good';
  if (score < 50) return 'warn';
  return 'default';
}

// Headline suggestions used by Results 3's narrative variant.
export const topSuggestions = [
  {
    headline: 'Hülsenfrüchte einbauen',
    detail: 'Ein Linsensalat als Mittagessen oder Hummus aufs Brot, zwei- bis dreimal pro Woche.',
  },
  {
    headline: 'Vollkornbrot statt Weissbrot',
    detail: 'Ein einfacher Tausch beim nächsten Einkauf. Dein Körper wird den Unterschied merken.',
  },
  {
    headline: 'Einmal pro Woche Fisch',
    detail: 'Egal ob frisch, geräuchert oder aus der Konserve. Eine Portion pro Woche reicht.',
  },
];
